import PredefinedAutocomplete from './PredefinedAutocomplete';
import connectContainer from './PredefinedAutocompleteContainer';

export default connectContainer(PredefinedAutocomplete);
